import React, { useCallback, useEffect, useState } from 'react';
import { ListChecks } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { WordingTab } from '@/components/bulletGroups/WordingTab';
import { CatalogueTab } from '@/components/bulletGroups/CatalogueTab';
import { PreviewTab } from '@/components/bulletGroups/PreviewTab';

const TABS = [
  { key: 'wording', label: 'Bullet wording' },
  { key: 'catalogue', label: 'Catalogue bullet groups' },
  { key: 'preview', label: 'Preview a job' },
];

// Bullet Matrix v2 — "Repairs Detailed as Follows:" groups, catalogue tokens and live preview.
export default function BulletGroupsPage() {
  const { api } = useAuth();
  const [tab, setTab] = useState('wording');
  const [data, setData] = useState({ groups: [], tokens: [] });
  const load = useCallback(async () => {
    try { setData((await api.get('/bullet-groups')).data); } catch (e) { toast.error(e?.response?.data?.detail || 'Failed to load'); }
  }, [api]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="bullet-groups-page" className="space-y-4">
      <div className="flex items-center gap-2">
        <ListChecks size={20} className="text-[#316536]" />
        <h1 className="text-2xl font-bold text-slate-900">Quote Bullets</h1>
      </div>
      <p className="text-sm text-slate-500 max-w-3xl">
        The "Repairs Detailed as Follows:" list on quotation letters. Each catalogue item belongs to one bullet group;
        lines in the same group (and same token values) are added together. Turn the new bullets on per quote type in
        Script Audit Studio → Quotation Letter → cell 6.
      </p>
      <div className="flex gap-1 border-b border-slate-200">
        {TABS.map(t => (
          <button key={t.key} data-testid={`bullet-tab-${t.key}`} onClick={() => setTab(t.key)}
            className={`px-3 py-2 text-sm font-semibold border-b-2 transition-colors ${tab === t.key ? 'border-[#316536] text-[#316536]' : 'border-transparent text-slate-500 hover:text-slate-800'}`}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'wording' && <WordingTab api={api} groups={data.groups} tokens={data.tokens} onSaved={load} />}
      {tab === 'catalogue' && <CatalogueTab api={api} groups={data.groups} tokens={data.tokens} />}
      {tab === 'preview' && <PreviewTab api={api} />}
    </div>
  );
}
